export default __webpack_public_path__ + "static/media/position.svg";